/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnUserGender } from './en-user-gender';
 /**
 *
 *
 * @export
 * @interface UpdateMemberDto
 */
export interface UpdateMemberDto {

    /**
     * @type {string}
     * @memberof UpdateMemberDto
     */
    firstName?: string;

    /**
     * @type {string}
     * @memberof UpdateMemberDto
     */
    lastName?: string;

    /**
     * @type {string}
     * @memberof UpdateMemberDto
     */
    fiscalCode?: string;

    /**
     * @type {string}
     * @memberof UpdateMemberDto
     */
    email?: string | null;

    /**
     * @type {string}
     * @memberof UpdateMemberDto
     */
    dateOfBirth?: string | null;

    /**
     * @type {number}
     * @memberof UpdateMemberDto
     */
    height?: number | null;

    /**
     * @type {number}
     * @memberof UpdateMemberDto
     */
    weight?: number | null;

    /**
     * @type {EnUserGender}
     * @memberof UpdateMemberDto
     */
    gender?: EnUserGender | null;

    /**
     * @type {string}
     * @memberof UpdateMemberDto
     */
    note?: string | null;

    /**
     * @type {number}
     * @memberof UpdateMemberDto
     */
    education?: number;
}
